import cx from 'classnames';

import { makeStyles } from '@mui/styles';
import Divider from '@classify/react-core-components/Divider';

import Typography from '@classify/react-core-components/Typography';

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  root: {
    display: 'flex',
    width: 288,
    paddingTop: spacing(2),
    paddingBottom: spacing(2),
    borderBottom: '2px solid transparent',
    boxSizing: 'border-box',
    [breakpoints.up('sm')]: {
      width: 340,
      paddingTop: spacing(4),
      paddingBottom: spacing(4),
    },
    [breakpoints.up('lg')]: {
      width: 368,
    },
  },
  iconContainer: {
    display: 'flex',
    flex: '1 0 auto',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 92,
    minWidth: 92,
    [breakpoints.up('sm')]: {
      maxWidth: 108,
      minWidth: 108,
    },
    [breakpoints.up('lg')]: {
      maxWidth: 122,
      minWidth: 122,
      padding: spacing(0, 2),
      boxSizing: 'border-box',
      justifyContent: 'flex-end',
    },
    '& > img': {
      maxWidth: 60,
      [breakpoints.up('sm')]: {
        maxWidth: '100%',
      },
    },
  },
  divider: {
    height: 64,
    [breakpoints.up('sm')]: {
      height: 80,
    },
  },
  dataContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: '2 0 auto',
    padding: spacing(0, 2),
  },
  number: {
    marginBottom: spacing(0.5),
  },
}));

export default function KeyDataItem({ icon, color, data, className = '' }) {
  const classes = useStyles();

  const { number, text } = data;

  return (
    <div className={cx(classes.root, className)} style={{ borderColor: `${color}` }}>
      <div className={classes.iconContainer}> {icon}</div>
      <Divider orientation="vertical" flexItem className={classes.divider} />
      <div className={classes.dataContainer}>
        <Typography
          variant="h1"
          component="p"
          className={classes.number}
          style={{ color: `${color}` }}
        >
          {number}
        </Typography>
        <Typography variant="body" component="span">
          {text}
        </Typography>
      </div>
    </div>
  );
}
